<template>
  <div class="con6">
    <div class="container">
      <p class="text-title">
        놀라긴 아직 일러요!<br />말랑톡의<br class="br-m" />
        the 드림 학습!
      </p>
      <ul>
        <!-- the 드림 01 -->
        <li class="dream01">
          <p class="dream-text0">the 드림 01</p>
          <p class="dream-text1 m">
            매일 업데이트되는<br />학습 컨텐츠로<br />영작에서 청취 및
            스피킹까지<br />한번에 쓱
          </p>
          <p class="dream-text1 pc">
            매일 업데이트되는 학습 컨텐츠로<br />영작에서 청취 및 스피킹까지
            한번에 쓱
          </p>
          <div>
            <div>
              <VueSlickCarousel ref="c1" v-bind="settings1" class="title-slide">
                <div>
                  <p>오늘의 한문장</p>
                </div>
                <div>
                  <p>기적의 쉐도잉</p>
                </div>
                <div>
                  <p>데일리 챌린지</p>
                </div>
                <div>
                  <p>로이터 영어 뉴스</p>
                </div>
              </VueSlickCarousel>
            </div>
            <div class="content-slide">
              <VueSlickCarousel ref="c2" v-bind="settings2">
                <div class="item">
                  <div class="img-wrap gray">
                    <img
                      src="@/assets/img/aitutorplus/con6/slide1.png"
                      alt="icon"
                    />
                  </div>
                </div>
                <div class="item">
                  <div class="img-wrap white">
                    <img
                      src="@/assets/img/aitutorplus/con6/slide2.png"
                      alt="icon"
                    />
                  </div>
                </div>
                <div class="item">
                  <div class="img-wrap white">
                    <img
                      src="@/assets/img/aitutorplus/con6/slide3.png"
                      alt="icon"
                    />
                  </div>
                </div>
                <div class="item">
                  <div class="img-wrap gray">
                    <img
                      src="@/assets/img/aitutorplus/con6/slide4.png"
                      alt="icon"
                    />
                  </div>
                </div>
              </VueSlickCarousel>
            </div>
            <div>
              <VueSlickCarousel ref="c2" v-bind="settings3" class="sub-slide">
                <div>
                  <p>미디어 속 <span>원어민 리얼 표현!</span></p>
                </div>
                <div>
                  <p>
                    <span>쉐도잉</span>으로 완성하는 <span>나의 유창성</span>
                  </p>
                </div>
                <div>
                  <p>매일 한 문장씩 완성하는 <span>영작 & 스피킹</span></p>
                </div>
                <div>
                  <p>매일 찾아오는 <span>글로벌 핫소식</span></p>
                </div>
              </VueSlickCarousel>
            </div>
          </div>
        </li>

        <!-- the 드림 02 -->
        <li>
          <p class="dream-text0">the 드림 02</p>
          <p class="dream-text1">실력 향상을 위한 복습관리</p>
          <ul class="content">
            <li>
              <img
                src="@/assets/img/aitutorplus/con6/icon0.png"
                alt="img"
                class="icon"
              />
              <p>학습현황&복습 안내</p>
              <p>
                <span>한 눈에 보이는 학습현황</span>과<br /><span
                  >꼼꼼한 복습 안내</span
                >로 다시 한번 실력 UP!
              </p>
              <video
                muted
                autoplay
                playsinline
                poster="@/assets/img/aitutorplus/con6/video1-poster.png"
                loop
                src="@/assets/img/aitutorplus/con6/video1.mp4"
              ></video>
            </li>
            <li>
              <img
                src="@/assets/img/aitutorplus/con6/icon1.png"
                alt="img"
                class="icon"
              />
              <p>나만의 표현집</p>
              <p>
                기억하고 싶은 표현이 있다면?<br /><span
                  >북마킹을 통해 유용한 표현만 모아</span
                ><br class="br-m" />
                집중 훈련!
              </p>
              <video
                muted
                autoplay
                playsinline
                poster="@/assets/img/aitutorplus/con6/video2-poster.png"
                loop
                src="@/assets/img/aitutorplus/con6/video2.mp4"
              ></video>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings1: {
        arrows: false,
        swipe: false,
        swipeToSlide: false,
        infinite: true,
        slidesToScroll: 1,
        focusOnSelect: false,
        slidesToShow: 4,
        asNavFor: null,
      },

      settings2: {
        arrows: false,
        swipeToSlide: false,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: "ease-out",
        focusOnSelect: true,
        touchMove: true,
        slidesToScroll: 1,
        slidesToShow: 3,
        centerMode: true,
        centerPadding: "0px",
        asNavFor: null,

        responsive: [
          {
            breakpoint: "1119px",
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },

      settings3: {
        fade: true,
        arrows: false,
        swipe: false,
        swipeToSlide: false,
        infinite: true,
        slidesToScroll: 1,
        focusOnSelect: true,
        slidesToShow: 1,
        asNavFor: null,
      },
    };
  },
  mounted() {
    this.settings1.asNavFor = this.$refs.c2;
    this.settings2.asNavFor = this.$refs.c1;
    this.settings3.asNavFor = this.$refs.c2;
  },
};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

video {
  display: block;
  width: 100%;
  object-fit: cover;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.con6 {
  padding: 86px 0;
  background-color: #18181b;

  @media screen and (min-width: 1200px) {
    padding: 174px 0;
  }

  .text-title {
    font-size: 30px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    margin-bottom: 46px;

    @media screen and (min-width: 1200px) {
      font-size: 52px;
      margin-bottom: 94px;
    }
  }

  .dream-text0 {
    font-size: 20px;
    font-weight: 700;
    color: #8b5cf6;
    text-align: center;
    margin-bottom: 26px;

    @media screen and (min-width: 1200px) {
      font-size: 25px;
      margin-bottom: 38px;
    }
  }

  .dream-text1 {
    font-size: 26px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    line-height: 32px;
    margin-bottom: 40px;

    @media screen and (min-width: 1200px) {
      font-size: 44px;
      line-height: 58px;
      margin-bottom: 82px;
    }

    &.m {
      @media screen and (min-width: 1200px) {
        display: none;
      }
    }

    &.pc {
      display: none;

      @media screen and (min-width: 1200px) {
        display: block;
      }
    }
  }

  .dream01 {
    padding: 48px 16px;
    background-color: rgba($color: #fff, $alpha: 0.05);
    border-radius: 26px;
    margin-bottom: 73px;

    @media screen and (min-width: 1200px) {
      padding: 110px 116px;
      margin-bottom: 190px;
    }
  }

  :deep(.title-slide) {
    margin-bottom: 36px;

    @media screen and (min-width: 1200px) {
      margin-bottom: 68px;
    }

    .slick-list {
      .slick-track {
        display: grid !important;
        grid-template-columns: repeat(2, 1fr);
        justify-content: center;
        gap: 8px;

        @media screen and (min-width: 1200px) {
          display: flex !important;
          justify-content: center;
          gap: 24px;
        }

        &::before,
        &::after {
          display: none;
        }

        .slick-slide {
          width: 100% !important;

          @media screen and (min-width: 1200px) {
            width: auto !important;
          }

          > div {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            padding: 14px 32px;
            background-color: #33353a;
            border-radius: 12px;
            cursor: pointer;

            @media screen and (min-width: 1200px) {
              height: auto;
              padding: 12px 24px;
              background-color: transparent;
              border-radius: 24px;
            }

            > div {
              > p {
                align-self: stretch;
                height: 100%;
                font-size: 14px;
                color: rgba($color: #fff, $alpha: 0.4);
                text-align: center;

                @media screen and (min-width: 1200px) {
                  align-self: auto;
                  font-size: 20px;
                }
              }
            }
          }

          &.slick-current {
            > div {
              background-color: #7b53eb;

              > div {
                > p {
                  color: #fff;
                  font-weight: 500;
                }
              }
            }
          }
        }
      }
    }
  }

  :deep(.content-slide) {
    .slick-list {
      .slick-track {
        display: flex;
        align-items: center;

        .slick-slide {
          > div {
            > div {
              .img-wrap {
                width: 232px;
                margin: 0 auto;
                border-radius: 34px;
                overflow: hidden;

                @media screen and (min-width: 1200px) {
                  width: 276px;
                }

                &.gray {
                  border: 5px solid #3d3c3c;
                }

                &.white {
                  border: 5px solid #3d3c3c;

                  @media screen and (min-width: 1200px) {
                    border: 5px solid #fff;
                  }
                }
              }
            }
          }

          // 활성화 된 거
          &.slick-current {
            > div {
              > div {
                .img-wrap {
                  @media screen and (min-width: 1200px) {
                    width: 320px;
                  }
                }
              }
            }
          }

          // 활성화 안 된 거
          &:not(.slick-current) {
            > div {
              > div {
                .img-wrap {
                  opacity: 0.25;
                }
              }
            }
          }
        }
      }
    }
  }

  :deep(.sub-slide) {
    .slick-list {
      .slick-track {
        .slick-slide {
          > div {
            > div {
              p {
                color: #bbbbbb;
                text-align: center;
                padding-top: 26px;

                span {
                  font-weight: 500;
                  color: #fff;
                }

                @media screen and (min-width: 1200px) {
                  font-size: 24px;
                  padding-top: 42px;
                }
              }
            }
          }
        }
      }
    }
  }

  .content {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 54px;
    max-width: 400px;
    margin: 0 auto;

    @media screen and (min-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 36px;
      max-width: 100%;
      height: 730px;
    }

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding-top: 28px;
      border-radius: 26px;
      overflow: hidden;
      width: 320px;
      height: 536px;
      margin: 0 auto;

      @media screen and (min-width: 1200px) {
        width: 100%;
        height: auto;
      }

      &:nth-of-type(1) {
        height: 512px;
        background-color: #f3f4f6;

        @media screen and (min-width: 1200px) {
          height: auto;
        }
      }

      &:nth-of-type(2) {
        background-color: #8b5cf6;
      }

      video {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 440px;
        margin: 0 auto;

        @media screen and (min-width: 1200px) {
          width: 100%;
          height: auto;
        }
      }

      @media screen and (min-width: 1200px) {
        padding-top: 48px;
      }

      &:nth-of-type(1) {
        p {
          z-index: 1;

          &:nth-of-type(1) {
            color: #8b5cf6;
          }

          &:nth-of-type(2) {
            color: #374151;
          }
        }
      }

      &:nth-of-type(2) {
        p {
          z-index: 1;

          &:nth-of-type(1) {
            color: #fff;
          }

          &:nth-of-type(2) {
            color: #f3f4f6;
          }
        }
      }

      .icon {
        width: 52px;
        margin-bottom: 14px;
        z-index: 1;
      }

      p {
        &:nth-of-type(1) {
          font-size: 26px;
          font-weight: 700;
          margin-bottom: 12px;
        }

        &:nth-of-type(2) {
          font-size: 18px;
          text-align: center;
          line-height: 27px;

          span {
            font-weight: 700;
          }
        }
      }

      .img {
        @media screen and (min-width: 1200px) {
          width: 482px;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
